import React from 'react';
import { Sparkles, BookOpen, MessageCircle, Image, Brain, FileText } from 'lucide-react';

function TokenUsageGuidea() {
  // Feature explanations with icons
  const featureDetails = {
    courses: { icon: BookOpen, label: 'AI-Generated Courses', tokens: 50 },
    topics: { icon: Brain, label: 'Learning Topics', tokens: 8 },
    quizzes: { icon: FileText, label: 'Interactive Quizzes', tokens: 10 },
    flashcards: { icon: Sparkles, label: 'Smart Flashcards', tokens: 10 },
    chat: { icon: MessageCircle, label: 'AI Chat Assistant', tokens: '1-10' },
    imageChat: { icon: Image, label: 'Visual Learning Chat', tokens: 50 },
  };
  return (
    <div className="bg-card rounded-xl border p-4">
      <h3 className="text-lg font-bold text-center mb-4 text-card-foreground">Understanding Your Token Usage</h3>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        {Object.entries(featureDetails).map(([key, detail]) => {
          const IconComponent = detail.icon;
          return (
            <div key={key} className="flex items-center gap-3 p-3 bg-muted/30 rounded-lg">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <IconComponent className="w-4 h-4 text-primary" />
              </div>
              <div className="min-w-0">
                <div className="font-medium text-card-foreground text-xs truncate">{detail.label}</div>
                <div className="text-xs text-muted-foreground">
                  {detail.tokens} token{detail.tokens !== 1 ? 's' : ''}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TokenUsageGuidea;
